import templateUrl from "./select-dropdown.html";
import assign from "lodash/assign";

export const selectDropdownComponent = {
  bindings: {
    list: "<",
    labelText: "@",
    selectedId: "<",
    defaultOption: "@",
    isOptionDisabled: "<",
    onChange: "&",
  },

  templateUrl,

  controller: class SelectDropdownComponent {
    constructor($parse) {
      "ngInject";
      this.$parse = $parse;
    }

    $onInit() {
      this._list = this.list.map((value) => assign(value, { selected: false }));
      this.selectedId = this.selectedId;
      this.isDisabled = !this.isOptionDisabled ? false : true;
    }

    _onChange(id) {
      this.list = this.list.map((value) => {
        value.selected = value.id === id ? true : false;
        return value;
      });

      this.onChange({ $event: id });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/select-dropdown/select-dropdown.component.js